import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectStageCheckList } from '../store/goLiveSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './GoLiveModal.css';

const GoLiveModal = ({ modalOnboarding, modalPractice }) => {
  // Redux state
  const stageCheckList = useAppSelector(selectStageCheckList);

  console.log("GoLiveModal: ", modalOnboarding, modalPractice);

  // Get go live data from the onboarding object
  const goLive = modalOnboarding?.stages?.goLive?.status;

  console.log("goLive: ", goLive);

  return (
    <div className="space-y-4">
      
      { modalOnboarding && (
        <div>
          <p className={`go-live-status${goLive ? ' go-live-status-active' : ' go-live-status-inactive'}`}>{goLive}</p>
          <GenericUpdateForm />
          
          {/* Checklist Component */}
          <Checklist 
            stage="goLive" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistoryGoLive = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="go-live-history-row">
      <td className="go-live-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="go-live-history-cell">
        Not set
      </td>
      <td className="go-live-history-cell">
        {onboarding.stages?.goLive?.status ? '✅' : '❌'}
      </td>
      <td className="go-live-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { GoLiveModal };
